<template>
  <b-row>
    <b-col cols="12">
      <b-overlay
        :show="$apollo.loading || mutationLoading"
        spinner-variant="primary"
      >
        <b-card title="Questions">
          <b-row
            v-for="(section, index) in questions"
            :key="index"
          >
            <b-col v-if="index !== 'null'">
              <h4 class="p-1 mb-2 rounded bg-light">
                <!-- {{ section }} -->
                {{ section.section.title }}
              </h4>
            </b-col>
            <b-col
              cols="12"
              class="px-2"
            >
              <b-row
                v-for="(questionsArr, questionIdx) in section.section.question"
                :key="questionIdx"
              >
                <b-col>
                  <b-form-group
                    :label="questionsArr.question"
                    :label-for="`question-${idx}`"
                    :label-class="`h5`"
                  >
                    <b-form-input
                      :id="`answer-${idx}`"
                      v-model="questionsArr.ans"
                      type="text"
                      required
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <!-- <b-row>
            <b-col class="px-2 d-flex align-items-end">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="mr-2 mt-1 py-1"
                @click="updateAnswer"
              >
                <span>Submit Answers</span>
              </b-button>
              <b-form-group
                v-if="$route.params.aid"
                label="Update Score"
                label-for="scoreLink"
                class="mb-0 flex-grow-1"
              >
                <b-form-input
                  id="scoreLink"
                  readonly
                  :value="scoreLink"
                />
              </b-form-group>
              <a
                v-if="$route.params.aid"
                :href="scoreLink"
                class="rounded btn"
              >
                <BIconBoxArrowUpRight />
                <a />

              </a></b-col>
          </b-row> -->
        </b-card></b-overlay>
    </b-col>
  </b-row>
</template>

<script>
import {
  // BButton,
  BCol, BFormGroup, BFormInput,
  // BFormFile,
  BRow, BCard,
  // BFormTextarea,
  // BIconBoxArrowUpRight,
  BOverlay,
} from 'bootstrap-vue'
// import vSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
// import { email, required } from '@core/utils/validations/validations'
import gql from 'graphql-tag'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    // BFormFile,
    // vSelect,
    // BButton,
    BCard,
    // BFormTextarea,
    // BIconBoxArrowUpRight,
    BOverlay,
  },
  data() {
    return {
      applicationData: '',
      mutationLoading: false,
      questions: [
        {
          id: 1,
          section: {
            id: 1,
            title: 'Section 1',
            question: [{ question: 'Is you are doing stocks', ans: 'Yes', answer_type: 'number' }, { question: 'question 2', ans: 'answer given by user', answer_type: 'number' }],
            input_type: '',
            prevHeight: 0,
          },
        },
        {
          id: 1,
          section: {
            id: 1,
            title: 'Section 2',
            question: [{ question: 'Is investmet in stocks is good', ans: 'Yes', answer_type: 'number' }, { question: 'question 2', ans: 'answer given by user', answer_type: 'number' }],
            input_type: '',
            prevHeight: 0,
          },
        },
      ],
    }
  },
  computed: {
    scoreLink() {
      return `${window.location.origin}/programs/application/score/${this.$route.params.pid}/${this.$route.params.apid}/${this.$route.params.aid}`
    },
    // questions() {
    //   this.applicationData.map(el => (el.programs_applicationresponsetables.length === 0 ? el.programs_applicationresponsetables.push({ response: '' }) : el.programs_startupresponsetables))
    //   return this.groupByKey(this.applicationData, 'section')
    // },
    answers() {
      const arr = []
      this.applicationData.map(r => arr.push(r.programs_applicationresponsetables[0]))
      // eslint-disable-next-line no-param-reassign,no-underscore-dangle
      arr.map(x => delete x.__typename)
      return arr
    },
  },
  methods: {
    groupByKey(array, key) {
      return Array.from(array).reduce((hash, obj) => {
        if (obj[key] === undefined) return hash
        return Object.assign(hash, { [obj[key]]: (hash[obj[key]] || []).concat(obj) })
      }, {})
    },
    updateAnswer() {
      this.mutationLoading = true
      this.$apollo.mutate({
        mutation: gql`mutation ($answers: [programs_applicationresponsetable_insert_input!]!) {
          insert_programs_applicationresponsetable(objects: $answers, on_conflict: {constraint: programs_applicationresponsetable_pkey, update_columns: response}) {
            affected_rows
          }
        }`,
        variables: {
          answers: this.answers,
        },
        update: (store, { data: { insert_programs_applicationresponsetable } }) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: insert_programs_applicationresponsetable.affected_rows ? 'Answers submitted successfully' : 'Failed to submit answers',
              icon: insert_programs_applicationresponsetable.affected_rows ? 'CheckIcon' : 'XIcon',
              variant: insert_programs_applicationresponsetable.affected_rows ? 'success' : 'warning',
            },
          })
          this.mutationLoading = false
        },
      })
    },
  },
  apollo: {
    applicationData: {
      query() {
        return gql`
        {
          programs_basicinfo(where: {id: {_eq: ${this.$route.params.pid}}}) {
            id,
            programs_applicationformstables(where: {id: {_eq: ${this.$route.params.apid}}}) {
              round_number
              title
              programs_applicationsquestionstables {
                id
                answer_type
                question
                section
                programs_applicationresponsetables(where: {applicant_id: {_eq: ${this.$route.params.aid || 0}}}) {
                  id
                  response
                  applicant_id
                }
              }
            }
          }
        }`
      },
      update: data => data.programs_basicinfo[0]?.programs_applicationformstables[0]?.programs_applicationsquestionstables,
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-wizard.scss';
@import '@core/scss/vue/libs/vue-select.scss';
</style>
